import * as Yup from 'yup';

import { createLocale } from 'locales';

import { SUPPORTED_DOC_TYPES } from 'constants/signup-flow-constants';

const localize = createLocale('freelancerPersonRegisterInformationPageLocales');

export default Yup.object().shape({
  file: Yup.mixed()
    .required(localize('fileRequired'))
    .test(
      'fileType',
      localize('wrongFileExtension'),
      (value) =>
        value !== null &&
        SUPPORTED_DOC_TYPES.includes(
          value.type as typeof SUPPORTED_DOC_TYPES[0],
        ),
    ),
});
